<template>
    <div>
        <PageTitle title="Preguntas y Respuestas"></PageTitle>
        <FirstBanner></FirstBanner>
        <div class="container">
            <ExpandableList v-if="!loading" :items="faqs" :link="link" />
            <LoaderComponent v-else></LoaderComponent>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/frontend/shared/PageTitle'
import FirstBanner from '@/components/frontend/shared/FirstBanner'
import ExpandableList from '@/components/frontend/components/ExpandableList.vue'
import LoaderComponent from "@/components/preloader/LoaderComponent";

export default {
    components: {
        PageTitle,
        FirstBanner,
        ExpandableList,
        LoaderComponent,
    },
    data() {
        return {
            faqs: [],
            loading: false,
            link: 'front.faqs.show',
        }
    },
    head: {
        title: function() {
            return {
                inner: 'Preguntas',
                complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
            }                         
        },
        meta: function() {
            return [
                {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
            ]                
        },
    },
    created() {
        this.getFaqs()
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig
        },
        manager() {
            return this.$store.getters.getFooter
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        getFaqs() {
            this.loading = true
            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                    tipo: this.manager.tipo === 1 ? 'deportivo' : 'teatro',
                },
            }

            this.$store
                .dispatch(this.config.getVuexAlias('front.faqs.index'), params)
                .then(res => {
                    this.faqs = res.data.data
                    this.loading = false
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                })
        },
    },
}
</script>
